module.exports = __webpack_public_path__ + "static/media/seed-of-life.15c6feee.jpg";